import { apiCall, createApiThunk } from '../../../utils/api';
import {
  deleteHolidayQuery,
  getHolidayDataQuery,
  uploadHolidayDataQuery,
} from './myHolidaysQueries';

export const getHolidaysDataThunk = createApiThunk('GET_HOLIDAYS_DATA', apiCall);
export const deleteHolidayThunk = createApiThunk('DELETE_HOLIDAY', apiCall);
export const addHolidayThunk = createApiThunk('ADD_HOLIDAY', apiCall);

export const getHolidaysData = () => (dispatch: AppDispatch) => {
  const url = getHolidayDataQuery();
  return dispatch(getHolidaysDataThunk({ url }));
};

export const deleteHoliday = (id: string) => (dispatch: AppDispatch) => {
  const url = deleteHolidayQuery(id);
  const method = 'DELETE';
  return dispatch(deleteHolidayThunk({ url, method }));
};

export const addHoliday = (data: any, newUpload: boolean) => (dispatch: AppDispatch) => {
  const url = uploadHolidayDataQuery();
  const method = newUpload ? 'POST' : 'PUT';
  return dispatch(addHolidayThunk({ url, method, data }));
};
